import { ai_decision } from '@lc/action/ai/ai_decision';
import { ai_seasonal } from '@lc/action/ai/ai_seasonal';
import { ai_summit } from '@lc/action/ai/ai_summit';
import {
	decisionCardResolution,
	decisionSummitDraft,
	decisionSummitWinter,
	decisionTurnOrder,
	normalSeasonalTurn,
} from '@lc/const/turnTypes';
import weightTable from '@lc/const/weights/bestWeights.json';
import { GameManager } from '@lc/interface/gameManager/types';
import { heuristicScore, softmaxPick } from '@lc/lib/ai_helper';
import {
	getPlayerStateWithId,
	isActivePlayerIdAI,
} from '@lc/lib/player_helper';

// TODO eed to update in future to account for reshuffling of order with PR
/**
 * AI will also call controller with decided action and mimic playerData so they will essentially
 * function just like a real player. Steal gameId from current playerData. Sick.
 *
 * @param gameState - you know what, it is black and yellow black and yello-
 * @param gameId - the id of the game you playin dingus
 * @param ticker - A point of contention. Do we push or unshift? descending or ascending?
 * @returns
 */
export async function aiCheck(gameManager: GameManager) {
	const { gameState, gameId, stateChangeHistory } = gameManager;

	let i = 0;
	while (gameState.gameStatus === 0 && isActivePlayerIdAI(gameState)) {
		// conduct ai turn, await DB updates
		if (gameState.gameStatus > 0) {
			break;
		}
		console.log('aiPerformTurn activePlayerId ' + gameState.activePlayerId);
		console.log(`ai iteration ${i}`);

		if (i > 1000) {
			console.log(`failure to resolve, step here`);
		}

		// console.log('gameState');
		// console.log(gameState);
		await aiPerformTurn(gameManager);
		console.log(
			'isActivePlayerIdAI activePlayerId ' + gameState.activePlayerId
		);

		i++;
	}

	return;
}

// TODO a set of weights per each type of turn
export async function aiPerformTurn(gameManager: GameManager) {
	const { gameState } = gameManager;
	switch (gameState.turnType) {
		case normalSeasonalTurn:
			await normalSeasonalTurnFunc(gameManager);
			break;
		case decisionSummitDraft:
			console.log(
				'ai player choosing summit card ' + gameState.activePlayerId
			);
			await ai_decision.chooseSummitCard(gameManager);
			break;
		case decisionTurnOrder:
			await ai_decision.chooseTurnOrder(gameManager);
			break;
		case decisionCardResolution:
			console.log(
				'ai player deciding card resolution' + gameState.activePlayerId
			);
			await ai_decision.chooseCardResolution(gameManager);
			break;
		case decisionSummitWinter:
			await ai_summit.winterSummitTurn(gameManager);
	}
}

async function normalSeasonalTurnFunc(gameManager: GameManager) {
	const { gameState } = gameManager;
	const activePlayerId = gameState.activePlayerId;
	console.log('ai id: ' + activePlayerId);
	// const aiState = getPlayerStateWithId(
	// 	gameState.playerStateArray,
	// 	activePlayerId
	// );

	const currentSeasonalWeight = weightTable[gameState.weightIndex];

	const preScore = heuristicScore(gameState, currentSeasonalWeight);

	// deep clone state, run a function on it, whichever has the highest probability is the move we do.

	// run each with a copied gameManager
	// get score
	// choose action based on probability

	const possibleActions = [
		ai_seasonal.buyBattery,
		ai_seasonal.buyFactory,
		ai_seasonal.buyPR,

		ai_seasonal.donation,

		ai_seasonal.playHand,
		ai_seasonal.playEquipmentOnTable,
		ai_summit.playSummitHand,

		ai_seasonal.storeEnergy,
		ai_seasonal.stealCarbon,

		//ai_decision.endTurn // ALWAYS LAST ACTION
	];

	// TODO have a minimum score threshold, if we can't get past that number, end turn
	// no energy left on factories
	let numTurns = currentSeasonalWeight.numTurns;

	while (numTurns > 0) {
		const scores: number[] = [];
		for (let i = 0; i < possibleActions.length; i++) {
			let gameManagerClone = structuredClone(gameManager);
			await possibleActions[i](gameManagerClone);
			scores.push(
				heuristicScore(
					gameManagerClone.gameState,
					currentSeasonalWeight
				)
			);
			(gameManagerClone as any) = null;
		}

		const moveIndex = softmaxPick(scores, preScore);

		console.log('scores: ' + scores);
		console.log('softmap index: ' + moveIndex);

		// if(moveIndex === scores.length -1) break; // ready for next turn

		await possibleActions[moveIndex](gameManager);

		numTurns--;
	}

	await ai_decision.endTurn(gameManager);
}

// send back ticker so socketController can use this
// keep choosing until activePlayerId is a non-ai player or we move on to PR Check
// but if we're doing this, we should just have AI deal with turnType and activePlayerId and do actions
// until activePlayerId is a human player...

/**
 * This needs to be a switch statement that figures out action given
 * turnType and if activePlayerId is an AI player
 *
 * The litmis test of goodness is if all AI can play an entire game together
 * up to the endgame
 */

// TODO, while the current player in the game is an AI, keep advancing until we return to a normal player's turn
// DO we reduce client sends to "clientMessage", and determine if they are doing something plausible in game instead of having all of these possible scenarios
// upside, crazy simplify socketController
// downside, beeg rewrite

// we advance every loop and update the state every loop. if our current player is AI, we conduct all of our server actions, even if we pass through the summit
// this might be good for the culling of the socket controller so we have a route entrance then an action controller regardless of the player being real or ai
// the jist of the issue is, my current player may be AI or real, I need to advance UNTIL THE INTERRUPT of a real player...
// so, i need to re-evaluate this from a stance of, the game can pause at any update of the gamestate, but when my real player needs to play, for my game Id I need
// to WAIT for their input...
// This is the ultimate alleviation of player input, taking away all control from player until absolutely necessary...
// given my structure, how can I make the game progress forward until i come to the testable condition that my player needs to intervene...
